import { ladderFor, recommend } from "@/components/arcade/SmartStake";

/* 🛡 Stake Guard — answers ONE question before a real-money play:
   "is this stake sensible for this balance?" Returns reasons + a safer pick. */
const MIN = 0.35;

export const assessStake = ({ stake, balance, recovOn = false, depth = 8 }) => {
  const s = Math.max(MIN, Number(stake) || 0);
  const bal = Number(balance) || 0;
  if (bal <= 0) return { risky: false, reasons: [], balance: bal };
  const reasons = [];
  const pct = (s / bal) * 100;
  if (s > bal * 0.05) {
    reasons.push(`This single stake is ${pct.toFixed(0)}% of your balance — above the 5% per-play guide. A short losing run at this size hits the account hard.`);
  }
  let worst = null;
  if (recovOn) {
    worst = ladderFor(s, depth).worst;
    if (worst >= bal) {
      reasons.push(`Recovery is ON: ${depth} straight losses from this stake would cost ~$${worst.toFixed(2)} — MORE than your whole balance. One bad streak could wipe the account.`);
    } else if (worst > bal * 0.5) {
      reasons.push(`Recovery is ON: ${depth} straight losses from this stake would cost ~$${worst.toFixed(2)} — over half your balance.`);
    }
  }
  if (!reasons.length) return { risky: false, reasons, balance: bal };
  let rec = recovOn ? recommend(bal, depth).stake : Math.floor(bal * 0.01 * 100) / 100;
  rec = Math.max(MIN, Math.round(rec * 100) / 100);
  // never suggest a stake whose own ladder is still dangerous for this balance
  const recStillRisky = recovOn && ladderFor(rec, depth).worst >= bal * 0.5;
  const recommended = rec < s && !recStillRisky ? rec : null;
  return { risky: true, reasons, worst, recommended, balance: bal, pct };
};
